import axios from "axios";

export const API_URL = 'https://hools-leader.xyz/api';

const $api = axios.create({
    withCredentials: false,
    baseURL: API_URL
});

export default $api;